/* Produkt-Berater – Fragen, Bewertung und Ergebnis (ohne Abhängigkeiten).
   Regeln: <script data-berater-regeln> (aus snippets/berater-regeln.liquid).
   Nur Produkte, deren Karte Liquid ausgegeben hat (veröffentlicht + verfügbar), kommen in Frage. */
(function () {
  'use strict';

  var root = document.querySelector('[data-berater]');
  if (!root) return;

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  var regeln;
  try {
    var roh = qs('[data-berater-regeln]').textContent;
    regeln = JSON.parse(roh.slice(roh.indexOf('{')));
  } catch (e) {
    return;
  }

  var SCHRITTE = ['z', 't', 'v', 'f', 'k'];
  var GUELTIG = {
    z: ['muskel', 'energie', 'figur', 'alltag', 'schlaf', 'haut'],
    t: ['0', '1', '2', '3'],
    v: ['0', '1'],
    f: ['pulver', 'kapseln', 'shots', 'gummies', 'egal'],
    k: ['0', '1']
  };
  var TEXTE = {
    z: { muskel: 'Muskelaufbau', energie: 'Ausdauer & Energie', figur: 'Abnehmen & Figur', alltag: 'Gesundheit & Alltag', schlaf: 'Schlaf & Erholung', haut: 'Haut & Haare' },
    t: { '0': 'kaum Training', '1': '1–2× Training', '2': '3–4× Training', '3': '5×+ Training' },
    v: { '1': 'vegan', '0': '' },
    f: { pulver: 'Pulver', kapseln: 'Kapseln/Tabletten', shots: 'Shots', gummies: 'Gummies', egal: '' },
    k: { '1': '', '0': 'ohne Koffein' }
  };
  var MAX = 4;

  var quiz = qs('[data-berater-quiz]');
  var ergebnis = qs('[data-berater-ergebnis]');
  var steps = qsa('[data-berater-step]');
  var back = qs('[data-berater-back]');
  var count = qs('[data-berater-count]');
  var bar = qs('[data-berater-bar]');
  var progress = qs('.berater__progress');
  var antworten = {};
  var aktuell = 0;

  function zeigeSchritt(i) {
    aktuell = i;
    steps.forEach(function (el, n) { el.hidden = n !== i; });
    back.hidden = i === 0;
    count.textContent = 'Frage ' + (i + 1) + ' von ' + SCHRITTE.length;
    bar.style.width = ((i + 1) / SCHRITTE.length * 100) + '%';
    progress.setAttribute('aria-valuenow', String(i + 1));
    var key = SCHRITTE[i];
    qsa('.berater__opt', steps[i]).forEach(function (b) {
      b.setAttribute('aria-pressed', antworten[key] === b.dataset.wert ? 'true' : 'false');
    });
  }

  /* Bewertung: Ziel ist Pflicht, vegan/Koffein/Training sind harte Filter, Form ist Vorliebe. */
  function bewerte(a) {
    var t = parseInt(a.t, 10);
    var liste = [];
    regeln.produkte.forEach(function (p, idx) {
      var karte = qs('[data-berater-karte="' + p.handle + '"]');
      if (!karte) return;                                   /* ausverkauft / nicht veröffentlicht */
      var gewicht = p.ziele[a.z];
      if (!gewicht) return;
      if (a.v === '1' && !p.vegan) return;
      if (a.k === '0' && p.koffein) return;                 /* u. a. kein Pre-Workout ohne Koffein-Ok */
      if (p.training > t) return;
      var punkte = gewicht * 10;
      if (a.f !== 'egal' && p.form === a.f) punkte += 8;
      if (t >= 2 && p.training >= 1) punkte += 2;
      liste.push({ p: p, karte: karte, punkte: punkte, idx: idx });
    });
    liste.sort(function (x, y) { return (y.punkte - x.punkte) || (x.idx - y.idx); });
    if (!liste.length) return liste;
    /* Schwache Treffer nur, wenn sonst weniger als 2 Vorschläge übrig bleiben. */
    var bester = liste[0].punkte;
    var gut = liste.filter(function (e, n) { return n < 2 || e.punkte >= bester - 20; });
    return gut.slice(0, MAX);
  }

  function zeigeErgebnis(a, scroll) {
    qsa('[data-berater-karte]').forEach(function (k) { k.hidden = true; });
    var treffer = bewerte(a);
    var liste = qs('[data-berater-liste]');
    treffer.forEach(function (e) {
      qs('[data-berater-grund]', e.karte).textContent = (e.p.grund_ziel && e.p.grund_ziel[a.z]) || e.p.grund;
      var fn = qs('[data-berater-fussnote]', e.karte);
      fn.textContent = e.p.fussnote || '';
      fn.hidden = !e.p.fussnote;
      liste.appendChild(e.karte);                           /* Reihenfolge = Rangfolge */
      e.karte.hidden = false;
    });
    qs('[data-berater-leer]').hidden = treffer.length > 0;
    qs('[data-berater-figur]').hidden = a.z !== 'figur';

    var teile = SCHRITTE.map(function (k) { return TEXTE[k][a[k]]; }).filter(Boolean);
    qs('[data-berater-auswahl]').textContent = 'Deine Auswahl: ' + teile.join(' · ');

    quiz.hidden = true;
    ergebnis.hidden = false;
    try {
      var url = new URL(window.location.href);
      SCHRITTE.forEach(function (k) { url.searchParams.set(k, a[k]); });
      window.history.replaceState(null, '', url.toString());
    } catch (e) { /* alte Browser: ohne teilbare URL */ }
    if (scroll) {
      ergebnis.focus({ preventScroll: true });
      ergebnis.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function neuStart() {
    antworten = {};
    ergebnis.hidden = true;
    quiz.hidden = false;
    try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* egal */ }
    zeigeSchritt(0);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', function (ev) {
    var opt = ev.target.closest('.berater__opt');
    if (opt) {
      antworten[SCHRITTE[aktuell]] = opt.dataset.wert;
      if (aktuell < SCHRITTE.length - 1) {
        zeigeSchritt(aktuell + 1);
        var erste = qs('.berater__opt', steps[aktuell]);
        if (erste && ev.detail === 0) erste.focus();        /* Tastatur: Fokus mitnehmen */
      } else {
        zeigeErgebnis(antworten, true);
      }
      return;
    }
    if (ev.target.closest('[data-berater-back]')) {
      if (aktuell > 0) zeigeSchritt(aktuell - 1);
      return;
    }
    if (ev.target.closest('[data-berater-neu]')) {
      neuStart();
      return;
    }
    if (ev.target.closest('[data-berater-teilen]')) {
      var link = window.location.href;
      var txt = qs('[data-berater-teilen-text]');
      if (navigator.share) {
        navigator.share({ title: 'Mein Produkt-Vorschlag – Fit-Inn Trier', url: link }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(link).then(function () {
          txt.textContent = 'Link kopiert';
          setTimeout(function () { txt.textContent = 'Ergebnis teilen'; }, 2500);
        });
      }
    }
  });

  /* Einstieg über URL: alle 5 Antworten → direkt Ergebnis; nur ?z= (Startseiten-Kachel) → ab Frage 2. */
  var params = new URLSearchParams(window.location.search);
  var ausUrl = {};
  SCHRITTE.forEach(function (k) {
    var w = params.get(k);
    if (w !== null && GUELTIG[k].indexOf(w) !== -1) ausUrl[k] = w;
  });
  if (SCHRITTE.every(function (k) { return k in ausUrl; })) {
    antworten = ausUrl;
    zeigeErgebnis(antworten, false);
  } else if (ausUrl.z) {
    antworten = { z: ausUrl.z };
    zeigeSchritt(1);
  } else {
    zeigeSchritt(0);
  }
})();
